import { ComplaintGroupedRowModel } from './ComplaintGroupedRowModel';

export function sortLinkedComplaintsOldestFirst(rows: ComplaintGroupedRowModel[]): ComplaintGroupedRowModel[] {
    return [...rows].sort((a, b) => new Date(a.openedAt).getTime() - new Date(b.openedAt).getTime());
}

/**
 * Fraud grouped table: blacklist rows show "-ad" suffix; whitelist rows strip a trailing "-ad" (any case) for display.
 */
export function formatFraudTableSenderName(senderName: string, isBlacklist: boolean): string {
    const trimmed = (senderName || '').trim();
    if (!trimmed) {
        return trimmed;
    }
    if (isBlacklist) {
        if (/-ad$/i.test(trimmed)) {
            return trimmed;
        }
        return `${trimmed}-ad`;
    }
    return trimmed.replace(/-ad$/i, '').trim();
}
